export default function gallery() {
  var $ = $ || jQuery

  var galleryContainers = $('.field--name-field-gallery-images'),
    imageThreshold = 4,
    numOfSlidesToShow = 0,
    galleryStyles = ''

  galleryContainers.each(function() {
    var galleryContainer = $(this)

    if (galleryContainer.children().length > imageThreshold) {
      numOfSlidesToShow = imageThreshold
      galleryStyles = 'carouselised populated'
    } else {
      numOfSlidesToShow = galleryContainer.children().length
      galleryStyles = 'carouselised'
    }

    galleryContainer.slick({
      draggable: false,
      slidesToShow: numOfSlidesToShow,
      slidesToScroll: 1,
      speed: 500,
      swipe: false,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            draggable: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            swipe: true
          }
        }
      ]
    })

    galleryContainer.addClass(galleryStyles)
  })

  $('.ateed-gallery-bg-img').on('click', function() {
    var imgIndex = Number(
      $(this).closest('.field--item').attr('data-image-index')
    )

    var paragraphNumber = $(this)
      .closest('.paragraph--type--gallery')
      .attr('data-gallery-collection-id')
      .split('/')
      .pop()

    $('.ateed-modal-wrapper').html(
      '<div class="modal fade" id="galleryModal" tabindex="-1" role="dialog" aria-labelledby="galleryModalLabel">' +
        '<gallery :current-image="currentImage" :change-image="changeImage" :image-text="imageText" :image-url="imageUrl" :loaded="loaded"></gallery>' +
        '</div>'
    )

    var template = `
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
              <div class="gallery-modal-body">
                <div class="previous-image" v-if="loaded">
                  <div class="ateed-indicator ateed-arrow-left-interactive" v-on:click="changeImage(currentImage - 1)"></div>
                </div>
                <div class="loader-anim" v-if="!loaded"></div>
                <div class="image-wrapper" v-if="loaded">
                  <div class="image-bg" v-bind:style="{ backgroundImage: 'url(' + imageUrl + ')' }"></div>
                  <div class="image-text">{{{ imageText }}}</div>
                  <div class="image-credit">{{ imageCredit }}</div>
                </div>
                <div class="next-image" v-if="loaded">
                  <div class="ateed-indicator ateed-arrow-right-interactive" v-on:click="changeImage(currentImage + 1)"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `

    Vue.component('gallery', {
      props: ['currentImage', 'changeImage', 'imageText', 'imageUrl', 'loaded'],
      template: template
    })

    var viewModel = new Vue({
      el: '.ateed-modal-wrapper',
      data: function() {
        return this.initialData()
      },
      computed: {
        imageText: function() {
          if (this.images.length > 0) {
            var caption = ''
            var divider = ''
            if (
              this.images[this.currentImage - 1] &&
              this.images[this.currentImage - 1].field_gallery_image_text &&
              this.images[this.currentImage - 1].field_gallery_image_text[0] &&
              this.images[this.currentImage - 1].field_gallery_image_text[0]
                .value
            ) {
              caption = this.images[this.currentImage - 1]
                .field_gallery_image_text[0].value
              divider = ':'
            }

            return (
              '<strong>' +
              this.currentImage +
              '/' +
              this.totalImages +
              divider +
              ' </strong>' +
              caption
            )
          }
          return ''
        },
        imageCredit: function() {
          return this.currentImage.credit || ''
        },
        imageUrl: function() {
          if (this.currentImageData) {
            return this.currentImageData.thumbnail[0].url
          }
          return ''
        },
        imageCounter: function() {
          return this.currentImage.url || ''
        }
      },
      methods: {
        initialData: function(galleryId) {
          return {
            galleryId: galleryId,
            images: [],
            totalImages: 0,
            loaded: false,
            currentImage: imgIndex + 1, // starts at 1
            currentImageData: undefined
          }
        },
        changeImage: function(imageNumber) {
          if (this.currentImage === imageNumber) return
          else if (imageNumber < 1) this.currentImage = this.totalImages
          else if (imageNumber > this.totalImages) this.currentImage = 1
          else if (this.currentImage !== imageNumber)
            this.currentImage = imageNumber

          this.getCurrentImageData()

          setTimeout(function() {
            $('.modal-content').animate({ scrollTop: 0 }, 100)
          }, 300)
        },
        getCurrentImageData: function() {
          this.loaded = false

          $.ajax({
            method: 'GET',
            url:
              this.images[this.currentImage - 1].field_gallery_image[0].url +
              '?_format=json',
            success: function(res) {
              // success
              this.currentImageData = res
              this.loaded = true
            }.bind(this),
            error: function() {
              // error
              this.currentImageData = undefined
              this.loaded = true
            }.bind(this)
          })
        },
        getImages: function(paragraphNumber) {
          this.loaded = false

          $.ajax({
            method: 'GET',
            url: '/entity/paragraph/' + paragraphNumber + '?_format=json',
            success: function(res) {
              // success
              this.images = res.field_gallery_images
              this.totalImages = res.field_gallery_images.length
              this.loaded = true

              this.getCurrentImageData()
            }.bind(this),
            error: function() {
              // error
              this.images = []
              this.totalImages = 0
              this.loaded = true
            }.bind(this)
          })
        }
      }
    })

    viewModel.$data = viewModel.initialData(paragraphNumber)
    viewModel.getImages(paragraphNumber)

    $('#galleryModal').modal({ show: true })
  })
}
